// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag_wrapper__k7i4z","light":"Tag_light__jY6AX","gray":"Tag_gray__QSICx","peach":"Tag_peach__f989r"};